export default {
  inheritAttr: false,
  props: {
    name: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    helpText: {
      type: [String, Function],
      default: '',
    },
    targetProperty: {
      type: String,
      default: 'data',
    },
    validate: {
      type: Function,
      default: () => ({ error: false }),
    },
    disabled: {
      type: [Boolean, Function],
      default: false,
    },
    default: undefined,
    value: undefined,
  },
  computed: {
    modelPath() {
      if (this.targetProperty) {
        return `${this.targetProperty}.${this.name}`;
      }
      return this.name;
    },
    model: {
      get() {
        if (typeof this.value === 'undefined') {
          return this.$store.getters.activeEditableObjectData({
            path: this.modelPath,
          });
        }
        return this.value;
      },
      set(value) {
        if (typeof this.value === 'undefined') {
          this.$store.commit('SET_ACTIVE_EDITABLE_OBJECT_DATA', {
            path: this.modelPath,
            value,
          });
        } else {
          this.$emit('change', value);
        }
      },
    },
    instanceData() {
      // Objeto com as props do módulo
      return this.$store.getters.activeInstance?.data;
    },
    itemData() {
      // Objeto com os campos do item específico (apenas dentro de lista)
      return this.$store.getters.activeEditableObjectData({
        path: this.modelPath.split('.').slice(0, -1).join('.'),
      });
    },
    isDisabled() {
      if (this.$store.getters.isViewerUser) {
        return true;
      }

      if (typeof this.disabled === 'function') {
        // A função disabled recebe como parâmetro um objeto com as props do módulo e seu this
        // é o objeto com os campos do item específico (se dentro de lista)
        return this.disabled.call(this.itemData, this.instanceData);
      }

      return this.disabled;
    },
    finalHelpText() {
      if (typeof this.helpText === 'function') {
        // Na função helpText, o seu this é um objeto com os campos do seu item correspondente (dentro de lista)
        return this.helpText.call(this.itemData, this.instanceData);
      }

      return this.helpText;
    },
    hasHelpText() {
      return (
        (typeof this.helpText === 'string' ||
          typeof this.helpText === 'function') &&
        /\S/.test(this.finalHelpText)
      );
    },
  },
  beforeMount() {
    if (
      typeof this.model === 'undefined' &&
      typeof this.default !== 'undefined'
    ) {
      this.model = this.default;
    }
  },
};
